/* eslint-disable react/button-has-type */
import { AnchorHTMLAttributes } from 'react';

type Props = {
  theme: 'light' | 'dark' | 'blue';
  size: 'small' | 'medium' | 'large';
} & AnchorHTMLAttributes<HTMLAnchorElement>;

const ButtonLink = ({ theme, size, children, ...props }: Props) => {
  const bgColor = theme === 'dark' ? 'bg-black' : theme === 'light' ? 'bg-white' : 'bg-main-blue';
  const textColor = theme === 'light' ? 'text-black' : 'text-white';
  const spacing = size === 'large' ? 'p-5' : size === 'small' ? 'p-2.5' : 'p-3.5';
  const fontSize = size === 'large' ? 'text-3xl leading-3xl' : 'text-sm leading-sm';

  return (
    <a
      {...props}
      className={`
      ${spacing}
      ${bgColor}
      ${textColor}
      ${fontSize}
      font-medium
      w-full 
      flex 
      justify-center 
      rounded-lg
      `}
      style={{ outline: 'none' }}
    >
      {children}
    </a>
  );
};

export { ButtonLink };
